(function () {

	// closeSearch fuori da header() così è sempre disponibile
	const closeSearch = () => {
		document.querySelectorAll(".header__search-inner").forEach((item) => {
			item.classList.remove("header__search-inner--open");
		});
		document.body.classList.remove("overflow-hidden-search");
		document.querySelector(".header__icon--summary.search-open-btn")
			?.classList.remove("search-is-open");
	};

	// Event delegation per chiudere la search cliccando sull'overlay
	document.addEventListener("click", (e) => {
		if (e.target.classList.contains("header__search-inner")) {
			closeSearch();
		}
	}, true); // true = capture phase, viene prima di qualsiasi altro listener

	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const menu = document.querySelector(
			".header__second-level .list-menu--inline",
		);
		const menuLinks = document.querySelectorAll(
			".header__second-level .list-menu-item",
		);
		const megaMenuLink = document.querySelector(".list-menu--megamenu");
		const search = document.querySelector("details-modal.header__search");
		const searchModal = document.querySelector(
			"details-modal.header__search > details",
		);
		const allSubmenu = document.querySelectorAll(".header__submenu");
		const searchOpenBtn = document.querySelectorAll(".search-open-btn");
		const searchOpenBtnFooter = document.querySelector(
			".search-open-btn--footer",
		);
		const searchInner = document.querySelectorAll(".header__search-inner");
		const searchPromoBg = document.querySelector(".search__modal");
		const searchPredictiveBg = document.querySelectorAll(".search-modal__form");
		const headerSimpleMenuLinks = document.querySelectorAll(
			".simple_mega_menu .header__submenu-li",
		);

		const blob = document.getElementById("blob");
		const track = document.querySelector(
			".header__second-level .list-menu--inline",
		);
		const activeItem = document
			.querySelector(
				".header__second-level .list-menu--inline .header__active-menu-item",
			)
			?.closest("li");

		let hasBlobPosition = false;

		if (blob) {
			blob.style.opacity = "0";
			blob.style.left = "0px";
			blob.style.top = "0px";
		}

		headerSimpleMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (e) => {
				headerSimpleMenuLinks.forEach((el) => {
					if (el === e.target) {
						el.querySelector(".header__submenu")?.classList.add("show-submenu");
						el.querySelector(".header__submenu")?.classList.remove("remove-submenu");
					} else {
						el.querySelector(".header__submenu")?.classList.remove("show-submenu");
						el.querySelector(".header__submenu")?.classList.add("remove-submenu");
					}
				});
			});
		});

		const addHeaderOverlay = (trigger) => {
			trigger?.addEventListener("mouseover", () => {
				document.querySelector(".header__overlay").classList.add("visible");
			});
			trigger?.addEventListener("mouseout", () => {
				document.querySelector(".header__overlay").classList.remove("visible");
			});
		};

		addHeaderOverlay(megaMenuLink);

		const makeBlob = (target = activeItem) => {
			if (!target || !blob) return;
			blob.style.width = `${target.clientWidth}px`;
			blob.style.height = `${target.clientHeight}px`;
			blob.style.left = `${target.offsetLeft}px`;
			blob.style.top = `${target.offsetTop}px`;
			blob.style.opacity = "1";
			blob.style.backgroundColor = "rgb(var(--color-accent))";
		};

		const hideBlob = () => {
			if (!blob) return;
			blob.style.backgroundColor = "transparent";
		};

		const animate = (from, to) => {
			if (!from || !to) return;
			const keyframes = [
				{ left: `${from.offsetLeft}px`, width: `${from.clientWidth}px`, top: `${from.offsetTop}px`, opacity: "1" },
				{ left: `${to.offsetLeft}px`, width: `${to.clientWidth}px`, top: `${to.offsetTop}px`, opacity: "1" },
			];
			const timing = { duration: 300, easing: "cubic-bezier(0.87, 0, 0.13, 1)", fill: "forwards" };
			blob.animate(keyframes, timing);
		};

		if (activeItem) {
			makeBlob(activeItem);
			blob.style.opacity = "1";
			hasBlobPosition = true;
		} else {
			hideBlob();
		}

		track?.addEventListener("mouseover", (e) => {
			const targetItem = e.target.matches(".list-menu-item")
				? e.target
				: e.target.closest(".list-menu-item");

			if (!targetItem || targetItem.id === "blob") return;

			blob.style.backgroundColor = "rgb(var(--color-accent))";

			if (!hasBlobPosition) {
				makeBlob(targetItem);
				blob.animate([{ opacity: 0 }, { opacity: 1 }], {
					duration: 300, easing: "ease-out", fill: "forwards",
				});
				hasBlobPosition = true;
				return;
			}

			animate(blob, targetItem);
		});

		track?.addEventListener("mouseleave", () => {
			if (activeItem) {
				animate(blob, activeItem);
			} else {
				hideBlob();
			}
		});

		window.addEventListener("resize", () => {
			if (activeItem) {
				makeBlob(activeItem);
			}
		});

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape") {
				closeSearch();
			}
		});

		const annBar = document.querySelector(".section-announcement");
		let annBarObserver;
		const createAnnBarObserver = () => {
			if (annBarObserver) annBarObserver.disconnect();
			annBarObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const annBarHeight = annBar?.getBoundingClientRect().height || 0;
							document.documentElement.style.setProperty(
								"--ann-height",
								`${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`,
							);
						} else {
							document.documentElement.style.setProperty("--ann-height", "0px");
						}
					});
				},
				{ threshold: Array.from({ length: 1000 }, (_, i) => i / 1000) },
			);
			if (annBar) annBarObserver.observe(annBar);
		};
		createAnnBarObserver();

		menuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (e) => {
				menuLinks.forEach((el) => {
					el.classList.add("list-menu-item--inactive");
					el.classList.remove("list-menu-item--active");
				});
				link.classList.remove("list-menu-item--inactive");
				link.classList.add("list-menu-item--active");
			});
		});

		menu?.addEventListener("mouseleave", () => {
			const activePageItem = Array.from(menuLinks).find((link) =>
				link.querySelector(".header__active-menu-item"),
			);
			menuLinks.forEach((el) => {
				el.classList.remove("list-menu-item--active");
				el.classList.remove("list-menu-item--inactive");
			});
			if (activePageItem) {
				activePageItem.classList.add("list-menu-item--active");
			}
		});

		allSubmenu.forEach((submenu) => {
			const links = submenu.querySelectorAll(
				".header__submenu-item:not(.header__submenu-item--grandchild)",
			);
			links.forEach((link) => {
				link.addEventListener("mouseenter", (e) => {
					e.stopPropagation();
					links.forEach((el) => { el.classList.add("header__submenu-item--inactive"); });
					link.classList.remove("header__submenu-item--inactive");
				});
			});
			submenu.addEventListener("mouseleave", (e) => {
				e.stopPropagation();
				links.forEach((el) => { el.classList.remove("header__submenu-item--inactive"); });
			});
		});

		// ===== Search: apertura =====
		const openSearch = () => {
			searchInner.forEach((item) => {
				item.classList.add("header__search-inner--open");
			});
			document.body.classList.add("overflow-hidden-search");
			document.querySelector(".header__icon--summary.search-open-btn")
				?.classList.add("search-is-open");
			trapFocus(document.querySelector(".search__content"));

			document.querySelector(".header__search-mobile-close")
				?.addEventListener("click", (e) => {
					e.stopPropagation();
					closeSearch();
				}, { once: true });
		};

		searchOpenBtn.forEach((btn) => {
			btn?.addEventListener("click", openSearch);
			btn?.addEventListener("keydown", (e) => {
				if (e.key === "Enter") openSearch();
			});
		});

		searchOpenBtnFooter.addEventListener("click", () => {
			window.scrollBy({ top: -1, behavior: "smooth" });
		});

		// Chiudi cliccando sull'overlay
searchInner.forEach((item) => {
    item.onclick = (e) => {
        if (e.target === e.currentTarget) {
            closeSearch();
        }
    };
});

		searchPromoBg?.addEventListener("click", (e) => {
			if (e.target.classList.contains("search__modal")) {
				closeSearch();
			}
		});

		searchPredictiveBg.forEach((item) => {
			item.addEventListener("click", (e) => {
				if (e.target.classList.contains("search-modal__form")) {
					closeSearch();
				}
			});
		});

		if (searchModal?.hasAttribute("open")) {
			header.classList.add("color-background-overlay-hidden");
		} else {
			header.classList.remove("color-background-overlay-hidden");
		}

		searchModal?.addEventListener("toggle", () => {
			if (searchModal.hasAttribute("open")) {
				header.classList.add("color-background-overlay-hidden");
			} else {
				header.classList.remove("color-background-overlay-hidden");
			}
		});
	};

	document.addEventListener("shopify:section:load", function () { header(); });
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);

	header();
})();